import { render, staticRenderFns } from "./Uso.vue?vue&type=template&id=400e7c84&scoped=true&"
import script from "./Uso.vue?vue&type=script&lang=js&"
export * from "./Uso.vue?vue&type=script&lang=js&"
import style0 from "./Uso.vue?vue&type=style&index=0&id=400e7c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400e7c84",
  null
  
)

export default component.exports